export default __webpack_public_path__ + "static/showsofindia-8b69a2b9fc6aa61d9b6342c4378175f1.png";